import { Display } from '@/components/Display/Display';
import errImgage from '@/assets/images/simulation/errImg.png';
import { useState } from 'react';
import ImageRender from '@/components/GrtImage/ImageRender';
const SimulationImg = (props) => {
    let { src, ...rest } = props;
    const [imgSrc, setImgSrc] = useState(src);
    const onError = () => {
        setImgSrc(errImgage);
    };
    return (
        <>
            <Display show={imgSrc}>
                <ImageRender onError={onError} src={imgSrc} {...rest} />
                {/* <img onError={onError} src={imgSrc} {...rest} /> */}
            </Display>
            <Display show={!imgSrc}>
                <div
                    {...rest}
                    style={{
                        backgroundColor: '#F0F0F0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <img
                        src={errImgage}
                        style={{
                            width: '60px',
                            objectFit: 'contain',
                            background: 'none'
                        }}
                    />
                </div>
            </Display>
        </>
    );
};

export default SimulationImg;
